module.exports = __webpack_public_path__ + "img/loading.a72011cc.gif";